<div class='card border-light'>
  @for (action of actions; track action; let i = $index) {
    <div>
      <div class="d-flex">
        <div class="fs-7 me-auto">Action {{i+1}}: {{action.key}}</div>
      </div>
    </div>
  }
</div>